import script from "./RequestMaterialAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestMaterialAdmin.vue?vue&type=script&setup=true&lang=js"

import "./RequestMaterialAdmin.vue?vue&type=style&index=0&id=09390c7a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09390c7a"]])

export default __exports__